import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PageFeedbackComponent } from './components/page-feedback/page-feedback.component';

/** "Was this page helpful?" widget (Unified Code criterion 40), mounted once by AppComponent. */
@NgModule({
  declarations: [PageFeedbackComponent],
  imports: [CommonModule, FormsModule, TranslateModule],
  exports: [PageFeedbackComponent],
})
export class FeedbackModule {}
